import { MutationTree } from "vuex";
import { MenuState } from "./types";

export const mutations: MutationTree<MenuState> = {
  setPinned(state, pinned: boolean) {
    localStorage.pinnedMenu = pinned;
    state.pinned = pinned;
  },
};
